import { FAQsItem } from '@mygpt/app/faqs';
import { Http } from '@mygpt/app/http';

interface FAQChildNoeParams {
  datasetId: string;
  hierarchy_parent_id: string;
  num_levels: number;
}

export interface FAQTreeItem extends FAQsItem {
  hierarchy_parent_id: string;
  child_nodes: FAQTreeItem[];
}

/**
 * 查树节点数据
 * @param params
 * @returns
 */
export const faqsChildNoe = (params: FAQChildNoeParams) => {
  const { datasetId, ...rest } = params;
  const { get } = Http.use();
  return get<FAQTreeItem[]>(`/datasets/${datasetId}/faqs/child_node`, {
    params: rest,
  });
};

export interface SearchNodeInfoByIdsParams {
  ai_id: string;
  ids: string[];
}

/**
 * 根据树节点ID查询节点信息
 * @param params
 * @returns
 */
export const searchNodeInfoByIds = (params: SearchNodeInfoByIdsParams) => {
  const { ai_id, ids } = params;
  const { post } = Http.use();
  return post(`/questions/${ai_id}/faqs/list`, ids);
};
